// @flow
import * as React from "react";
import { Link } from "react-router-dom";
import type { Tag } from "./types";
import { removeTag } from "./util";
import { useQuery } from "../../utils/hooks";

type Props = {
  tags: Tag[],
  setTags: (any) => any,
};
export default function Sidebar(props: Props): React.Node {
  const query = useQuery();
  return (
    <div className="fixed h-screen z-10 w-screen md:w-56 lg:w-96 overflow-y-auto bg-gray-100 pt-10">
      <ul className="flex flex-col mx-8 space-y-6 text-lg items-start">
        {props.tags.map((item, index) => (
          <li key={index} className="flex flex-row w-full">
            <Link
              to={`/your-timetables?tagId=${item.uuid}`}
              className={`flex-grow ${query.get("tagId") === item.uuid ? "text-orange" : "hover:text-orange"}`}
              onClick={() => props.setShow(false)}
            >
              {item.name}
            </Link>
            <button
              className="t-esc block text-xl hover:text-orange mr-1 w-min"
              onClick={() => removeTag(item.uuid, props.tags, props.setTags)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
